export default __webpack_public_path__ + "static/media/Paloma_9781408349618.d401ae37.jpg";